import { defineMessage } from 'services/localization';

export const messages = {
    bubbleText: defineMessage('creation_of_airwallex_batch_payment'),
    title: defineMessage('requesters_will_be_able_ubmit_them_for_approval'),
    paymentCreation: defineMessage('payment_creation'),
    description: defineMessage('requesters_will_be_able_ubmit_them_for_approval'),
};
